<template>
  <v-card-text>
    <v-tabs v-model="tab" align-tabs="center">
      <v-tab value="missingProducts">{{ $t('mission-planning.info.last-reading.missing-dno-products') }}</v-tab>
      <v-tab value="outOfStockProducts">{{ $t('mission-planning.info.last-reading.out-of-stock-products') }}</v-tab>
    </v-tabs>
    <v-tabs-window v-model="tab">
      <v-tabs-window-item value="missingProducts">
        <missing-d-no-products :reading="reading" :point-of-sale="pointOfSale" :tags="productTags" />
      </v-tabs-window-item>
      <v-tabs-window-item value="outOfStockProducts">
        <out-of-stock-products :reading="reading" :tags="productTags" />
      </v-tabs-window-item>
    </v-tabs-window>
  </v-card-text>
</template>

<script setup>
import {computed, inject, ref} from 'vue';
import MissingDNoProducts from "./MissingDNoProducts.vue";
import OutOfStockProducts from "./OutOfStockProducts.vue";

const props = defineProps({
  reading: {
    required: false,
    default: []
  },
  pointOfSale: {
    required: true
  }
});
const tab = ref(null)
const currentConfiguration = inject('currentConfiguration');
const productTags = computed(() =>
    currentConfiguration.value?.catalog?.tag || {}
)

</script>